module.exports = __webpack_public_path__ + "static/img/icon vip nhy.8668bf85.svg";